import { push } from 'connected-react-router';

import {
    canSendDocument,
    getIsReadyToSendAfterReview,
    isReadyToSignAfterReview,
} from '../../services/documents/utils';

import { getLocationQuery, stringifyLocationQuery } from '../../lib/url';
import { getLocalStorageItem, setLocalStorageItem } from '../../lib/webStorage';
import { DocumentFolder } from '../../services/enum';
import constants from './constants';

export const redirectToDefaultFolderOrCall = (
    { search, pathname },
    callback,
    dispatch,
) => {
    const query = getLocationQuery({ search });
    if (!query.folder_id && !query.is_archived) {
        dispatch(
            push({
                pathname,
                search: stringifyLocationQuery({
                    ...query,
                    folder_id: DocumentFolder.NOT_INTERNAL.value,
                }),
            }),
        );
    } else if (callback) {
        callback();
    }
};

const getDefaultDocListColumns = (isInternal, isArchived) => {
    if (isInternal) {
        return constants.INTERNAL_DOCUMENT_LIST_COLUMNS;
    }
    if (isArchived) {
        return constants.ARCHIVED_DOCUMENTS_LIST_COLUMNS;
    }

    return constants.DOCUMENT_LIST_COLUMNS;
};

export const getTableColumnsSettings = (documentFields) => {
    // TODO: Browser API location usage is discouraged, consider obtainig location of react-router
    const documentsFolder = new URLSearchParams(window.location.search).get(
        'folder_id',
    );
    const isArchived = new URLSearchParams(window.location.search).get(
        'is_archived',
    );
    const isInternal = documentsFolder === DocumentFolder.INTERNAL.value;

    let columns = getDefaultDocListColumns(isInternal, isArchived);

    if (documentFields && documentFields.length > 0) {
        const columnsFromCompanyDocumentFields = documentFields.map(
            (field) => ({
                name: field.id,
                title: field.name,
                text: field.name,
                isActive: false,
                sort: field.id,
                field,
            }),
        );
        columns = [...columns, ...columnsFromCompanyDocumentFields];
    }

    const storageKey = isInternal
        ? constants.WS_KEY_INTERNAL_DOCUMENT_LIST_SETTINGS
        : constants.WS_KEY_DOCUMENT_LIST_SETTINGS;

    const storageSettings = getLocalStorageItem(storageKey);

    return { columns, storageKey, storageSettings };
};

export const getPersistedTablePinnedIconsSettings = () =>
    getLocalStorageItem(constants.WS_KEY_DOCUMENT_LIST_PINNED_ICONS_SETTINGS);

/**
 * @typedef {object} IconSetting
 * @property {string} name
 * @property {string} title
 * @property {boolean} isActive
 * @property {boolean} isIcon
 * @property {string} side
 */

/**
 * @param {IconSetting[]} pinnedIconsSettings
 * @returns {{[string]: IconSetting}}
 */
export const getFormattedPinnedIconsSettings = (pinnedIconsSettings) => {
    return pinnedIconsSettings.reduce((result, pinnedIcon) => {
        result[pinnedIcon.name] = pinnedIcon;
        return result;
    }, {});
};

/**
 * @param {array} data
 * @return {void}
 */
export const saveTablePinnedIconsSettings = (data) =>
    setLocalStorageItem(
        constants.WS_KEY_DOCUMENT_LIST_PINNED_ICONS_SETTINGS,
        data,
    );

export const getIsReviewNeededBeforeAction = (docs, currentCompanyEdrpou) =>
    docs.some((doc) =>
        canSendDocument(doc, currentCompanyEdrpou)
            ? !getIsReadyToSendAfterReview(doc)
            : !isReadyToSignAfterReview(doc),
    );
